import MarketingLayout from '../layouts/MarketingLayout.jsx'
import SEOHead from '../components/SEOHead.jsx'

export default function LegalPage() {
  return (
    <MarketingLayout>
      <SEOHead
        title="Mentions légales"
        description="Mentions légales du site KartQuiz — éditeur, hébergement, propriété intellectuelle."
        canonical="/mentions-legales"
        robots="noindex, follow"
      />

      <section className="bg-[#F8FAFC] py-16">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-display font-semibold text-4xl text-kart-night mb-2">Mentions légales</h1>
          <p className="text-slate-400 text-sm">Dernière mise à jour : mai 2026</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-6 prose prose-slate max-w-none">

          <h2>Éditeur du site</h2>
          <p>
            Le site KartQuiz (<a href="https://kartquiz.fr">https://kartquiz.fr</a>) est édité par :
          </p>
          <p>
            <strong>BCOMING.Digital</strong><br />
            SIRET : 877 976 571 00019<br />
            Siège social : Lyon (69005), France<br />
            Responsable de la publication : Brice ANTOINE<br />
            Contact : <a href="mailto:contact@kartquiz.fr">contact@kartquiz.fr</a>
          </p>

          <h2>Hébergement</h2>
          <p>Ce site est hébergé par :</p>
          <p>
            <strong>Vercel Inc.</strong><br />
            340 S Lemon Ave #4133<br />
            Walnut, CA 91789, USA<br />
            <a href="https://vercel.com" target="_blank" rel="noopener noreferrer">https://vercel.com</a>
          </p>
          <p>
            L'application backend est hébergée par Railway (États-Unis) avec stockage des données utilisateurs en Europe (Supabase, région Frankfurt).
          </p>

          <h2>Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments composant le site KartQuiz (textes, images, vidéos, logos, code source) sont la propriété exclusive de BCOMING.Digital, sauf mention contraire. Toute reproduction, représentation ou diffusion, totale ou partielle, est interdite sans autorisation écrite préalable.
          </p>

          <h2>Crédits</h2>
          <p>
            Conception et développement : BCOMING.Digital — Lyon, France.
          </p>

          <h2>Données personnelles</h2>
          <p>
            Pour toute information sur le traitement de vos données personnelles, consultez notre{' '}
            <a href="/confidentialite">politique de confidentialité</a>.
          </p>

          <h2>Cookies</h2>
          <p>
            KartQuiz n'utilise pas de cookies publicitaires ou de tracking tiers. Aucun bandeau de consentement cookies n'est nécessaire.
          </p>

          <h2>Liens hypertextes</h2>
          <p>
            KartQuiz ne peut être tenu responsable du contenu des sites vers lesquels il renvoie. La création de liens vers KartQuiz est libre sous réserve de ne pas porter atteinte aux intérêts de BCOMING.Digital.
          </p>
        </div>
      </section>
    </MarketingLayout>
  )
}
